export const socialMaster = window._env_.API_URL;
export const endpoints = {
    'PROFILE': '/api/users/{0}/profiles',
    'CODE': '/api/code2/{0}',
    'VCARD': '/api/code2/{0}/vcard',
    'SOCIALCOUNTER': '/api/social-media/{0}'
};